export const DateRange = Object.freeze({
	Today: '0d',
	Past7Days: '7d',
	Past30Days: '1m',
	Past3Months: '3m',
	Past6Months: '6m',
	Past12Months: '1y',
	Past2Years: '2y',
	All: 'all',
	Custom: 'custom',
});

export default Object.freeze([
	{
		label: 'Today',
		value: DateRange.Today,
		dataqa: 'date-range-today',
	},
	{
		label: 'Past 7 Days',
		value: DateRange.Past7Days,
		dataqa: 'date-range-past-7-days',
	},
	{
		label: 'Past 30 Days',
		value: DateRange.Past30Days,
		dataqa: 'date-range-past-30-days',
	},
	{
		label: 'Past 3 Months',
		value: DateRange.Past3Months,
		dataqa: 'date-range-past-3-months',
	},
	{
		label: 'Past 6 Months',
		value: DateRange.Past6Months,
		dataqa: 'date-range-past-6-months',
	},
	{
		label: 'Past 12 Months',
		value: DateRange.Past12Months,
		dataqa: 'date-range-past-12-months',
	},
	{
		label: 'Past 2 Years',
		value: DateRange.Past2Years,
		dataqa: 'date-range-past-2-years',
	},
	{
		label: 'All',
		value: DateRange.All,
		dataqa: 'date-range-all',
	},
	{
		label: 'Custom Date Range',
		value: DateRange.Custom,
		dataqa: 'date-range-custom',
	},
]);
